// ── Floating contact panel (right-side sidebar) ──────────────────────────
// Toggles the slide-in panel. Used by the "Message" sidebar tab and the
// panel's close button (inline onclick in partials/main.php).
function togglePanel() {
  const p = document.getElementById("fsb-panel");
  if (!p) return;
  if (p.classList.contains("hidden")) {
    p.classList.remove("hidden");
    p.classList.add("flex");
  } else {
    p.classList.add("hidden");
    p.classList.remove("flex");
  }
}

// Toggles the left-edge "Google Reviews" slide-in panel (shown below 1101px,
// where the fixed desktop review widget is hidden). Opened by the left tab and
// its own close button (inline onclick in partials/main.php).
function toggleReviews() {
  const p = document.getElementById("reviews-panel");
  if (!p) return;
  if (p.classList.contains("hidden")) {
    p.classList.remove("hidden");
    p.classList.add("flex");
  } else {
    p.classList.add("hidden");
    p.classList.remove("flex");
  }
}

// Opens the contact panel and selects a specific tab. Used by the sticky mobile
// contact bar (📞 Call Back / ✉️ Email Us). On mobile the panel is centered as a
// modal; on desktop it's the right-side slide-in.
function openContact(tab) {
  const p = document.getElementById("fsb-panel");
  if (!p) return;
  p.classList.remove("hidden");
  p.classList.add("flex");
  const tabs = document.querySelectorAll(".ftab");
  tabs.forEach((t) => {
    t.classList.remove("bg-red", "text-white");
    t.classList.add("bg-white", "text-muted");
  });
  document.querySelectorAll(".fpanel-section").forEach((s) => s.classList.add("hidden"));
  const sec = document.getElementById("tab-" + tab);
  if (sec) sec.classList.remove("hidden");
  const active = tab === "email" ? tabs[1] : tabs[0];
  if (active) {
    active.classList.add("bg-red", "text-white");
    active.classList.remove("bg-white", "text-muted");
  }
}

// Switches the panel between the "Call Back" and "Email Us" forms.
function switchTab(btn, tab) {
  document.querySelectorAll(".ftab").forEach((t) => {
    t.classList.remove("bg-red", "text-white");
    t.classList.add("bg-white", "text-muted");
  });
  btn.classList.remove("bg-white", "text-muted");
  btn.classList.add("bg-red", "text-white");
  document.querySelectorAll(".fpanel-section").forEach((s) => s.classList.add("hidden"));
  const sec = document.getElementById("tab-" + tab);
  if (sec) sec.classList.remove("hidden");
}

// AOS scroll animations — only init if the library was loaded (opt-in via $useAos in config.php)
window.addEventListener("load", () => {
  if (typeof AOS !== "undefined") {
    AOS.init({ disable: "mobile" });
  }
});

document.querySelectorAll('a[href="#"]').forEach((link) => {
  link.addEventListener("click", (e) => e.preventDefault());
});

// Smooth scroll for anchor links without updating the URL hash
// Select all anchor links that start with # but are not just '#'
document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((link) => {
  link.addEventListener("click", function (e) {
    const targetId = this.getAttribute("href").slice(1);
    const target = document.getElementById(targetId);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth" });
      // Do not update the URL hash
      // Optionally, you can manage focus for accessibility:
      target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true });
    }
  });
});

